import { ConstructionOutlined, Visibility, VisibilityOff } from "@mui/icons-material";
import { Box, IconButton, Paper } from "@mui/material";
import { useSnackbar } from "notistack";
import { useEffect } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import RenderUserRedirect from "../../components/cellRender/RenderUserRedirect";
import NTMXGrid, { timestampFormatter } from "../../components/NTMXGrid";
import { useReportType } from "../../constants/publicUtilityRecord";
import { firebaseDatabase } from "../../firebase";
import { get, USERS } from "../../services/Client";
import { useSynchronizedData } from "../../services/FirebaseManager";
import { useGetProfileUser } from "../../services/UserDataManager";
import StatusIndicator from "../../components/Statusindicator";
import NTMButton from "../../components/NTMButton";

export default function ReportList({ reports, onReportClick, disabled }) {
    const { t } = useTranslation();
    const reportType = useReportType();
    const [isShowingReports, setIsShowingReports] = useState(false)

    const col = [
        {
            field: 'createdBy',
            headerName: t('creator'),
            renderCell: (params) => <RenderUserRedirect value={params.row.createdBy} url={params.row.createdBy} showUsername />,
            width: 200,
            // valueGetter: ({value}) => (get(USERS, {elem: value}).than((user) => user.username ))
        }, {
            field: 'createdAt',
            headerName: t('creationDate'),
            ...timestampFormatter,
            width: 200,
        }, {
            field: 'notes',
            headerName: t('notes'),
            width: 200,
        }, {
            field: 'type',
            headerName: t('type'),
            valueGetter: ({ value }) => reportType[value],
            width: 200,
        },
        {
            field: 'deleted',
            headerName: t('status'),
            valueGetter: ({ value }) => (!value ? t('active') : t('notActive')),
            renderCell: ({ row }) => <StatusIndicator color={'primary'} isActive={!row.deleted} />,
            width: 200,
        },
        {
            headerName: t('details'),
            field: "details",
            width: 90,
            sortable: false,
            disableColumnMenu: true,
            resizable: false,
            renderCell: params => <IconButton onClick={() => onReportClick(params.row)}><Visibility /></IconButton>
        }
    ]

    return <Box sx={{
        '& .MuiDataGrid-root': {
            opacity: isShowingReports ? 1 : 0.5
        }
    }}
    >
        <Box sx={{ textAlign: 'center' }}>
            <NTMButton
                /* sx={{ position: 'absolute', zIndex: 100, marginTop: 40, marginLeft: 'calc(50% - 6em - 46px - 20px - 2px)' }} */
                startIcon={isShowingReports ? <Visibility /> : <VisibilityOff />}
                title={isShowingReports ? t('hide') : t('show')}
                onClick={() => setIsShowingReports(isShowingReports => !isShowingReports)} outlinedVariant disabled={disabled}
                sx={{ width: 'calc(8em + 20px)', justifyContent:'flex-start' }}
            ></NTMButton>
        </Box>
        <NTMXGrid
            key={"report-table"}
            columns={col}
            rows={isShowingReports ? reports : []}
            getRowId={(row) => reports && row.key}
        />

    </Box>
}